<template>
    <div class="container">
        <back-button location="/technologies"></back-button>

        <h1 class="title">Web</h1>
        <div class="logo swing-animation">
            <img src="../../assets/images/Web.svg"/>
        </div>
        <div class="content">
            <div class="java-version-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">Front-end frameworks as used by Entelectuals on their projects</p>
                    <apex-charts type="bar" :options="versionOptions" :series="versionSeries" class="chart" height="250"></apex-charts>
                </div>
                <p class="fun-fact">Angular and React are the most popular front-end frameworks</p>
            </div>
            <div class="java-module-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">SCSS and LESS are the most popular CSS preprocessors</p>
                    <apex-charts type="radialBar" :options="buildOptions" :series="buildSeries"
                                class="chart"></apex-charts>
                </div>
            </div>
            <div class="java-serve-chart">
                <div class="chart-group">
                    <p class="chart-sub-title">UI frameworks as used by Entelectuals on their projects</p>
                    <apex-charts type="donut" :options="moduleOptions" :series="moduleSeries" class="chart"></apex-charts>
                </div>
                <p class="fun-fact">12% of web applications are Progressive Web Applications</p>
            </div>
            <div class="java-build-chart">
                <p class="fun-fact">64% of web developers use TypeScript</p>
                <div class="chart-group">
                    <p class="chart-sub-title">Modules used by Entelectuals in JavaScript projects</p>
                    <apex-charts type="bar" :options="serveOptions" :series="serveSeries" class="chart" height="250"></apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import VueApexCharts from "vue-apexcharts/src";
    import BackButton from "../../widgets/BackButton";

    export default {
        components: {
            'apex-charts': VueApexCharts,
            BackButton
        },
        data: function () {
            return {
                versionOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#8EC63F', '#008AD0', '#B51E8E', '#D8181F', '#00994C', '#009EA5', '#F7941D'],
                    labels: ['Vue', 'Knockout', 'Angular 2', 'Angular 1', 'React', 'Jquery', 'Angular 4+'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true,
                            horizontal: true
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    yaxis: {
                        categories: ['Vue', 'Knockout', 'Angular 2', 'Angular 1', 'React', 'Jquery', 'Angular 4+'],
                        labels: {
                            style: {
                                colors: ['#fff', '#fff', '#fff', '#fff', '#fff', '#fff', '#fff'],
                                fontSize: '14px'
                            }
                        }
                    },
                    xaxis: {
                        labels: {
                            style: {
                                colors: '#FFF',
                            },
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                versionSeries: [{
                    name: 'Usage',
                    data: [2.6, 9.1, 10.4, 17.8, 23, 34.3, 56.5]
                }],
                buildOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#F7941D', '#008AD0', '#B51E8E', '#8EC63F'],
                    labels: ['CSS', 'SCSS', 'LESS', 'SASS'],
                    tooltip: {
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    dataLabels: {
                        name: {
                            show: false,

                        },
                        value: {
                            show: false,
                        },
                        formatter: function (val, opt) {
                            if (val < 5)
                                return '';
                            return `${opt.w.globals.labels[opt.seriesIndex]}: ${Math.round(val)}%`;
                        },
                    },
                    plotOptions: {
                        radialBar: {
                            offsetY: -30,
                            startAngle: 0,
                            endAngle: 300,
                            hollow: {
                                margin: 5,
                                size: '30%',
                                background: 'transparent',
                                image: undefined,
                            },
                            track: {
                                opacity: 0.1
                            },
                            dataLabels: {
                                name: {
                                    show: false,
                                },
                                value: {
                                    color: '#fff',
                                    offsetY: 4
                                }
                            }
                        }
                    },
                    legend: {
                        show: true,
                        floating: true,
                        fontSize: '16px',
                        position: 'left',
                        verticalAlign: 'top',
                        textAnchor: 'end',
                        labels: {
                            useSeriesColors: true,
                        },
                        markers: {
                            size: 0
                        },
                        itemMargin: {
                            vertical: 7,
                        },
                        containerMargin: {
                            left: 160,
                            top: 16
                        }
                    },
                    responsive: [{
                        breakpoint: 599,
                        options: {
                            legend: {
                                show: true,
                                fontSize: '16px',
                                position: 'bottom',
                                textAnchor: 'start',
                                labels: {
                                    useSeriesColors: false,
                                    color: '#fff'
                                },
                                markers: {
                                    size: 5
                                },
                                containerMargin: {
                                    left: 0,
                                    top: 0
                                }
                            },
                            plotOptions: {
                                radialBar: {
                                    offsetY: 0,
                                    startAngle: 270,
                                    endAngle: 90,
                                }
                            },
                        }
                    }]
                },
                buildSeries: [43.5, 38.3, 22.6, 20],
                moduleOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    legend: {
                        labels: {
                            color: '#FFF'
                        },
                        position: 'bottom',
                    },
                    colors: ['#F7941D', '#008AD0', '#B51E8E', '#009EA5'],
                    labels: ['Material Flavor', 'Bootstrap', 'Custom', 'Other'],
                    tooltip: {
                        enabled: true,
                        y: {
                            formatter: (value) => `${value}%`
                        }
                    },
                    stroke: {
                        width: 0
                    },
                    fill: {
                        patern: {
                            width: 500
                        }
                    },
                    dataLabels: {
                        formatter: function (val, opt) {
                            if (val < 12)
                                return '';
                            return `${opt.w.globals.labels[opt.seriesIndex]}: ${Math.round(val)}%`;
                        },
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%',
                            },
                        }
                    },
                    responsive: [{
                        breakpoint: 599,
                        options: {
                            dataLabels: {
                                formatter: function (val) {
                                    if (val < 5)
                                        return '';
                                    return `${val}%`;
                                },
                            },
                        }
                    }]
                },
                moduleSeries: [10.5, 62.6, 12.2, 14.7],
                serveOptions: {
                    chart: {
                        toolbar: {
                            show: false
                        }
                    },
                    colors: ['#8EC63F', '#008AD0', '#B51E8E', '#D8181F', '#00994C', '#009EA5', '#F7941D'],
                    labels: ['Browserify', 'Grunt', 'SystemJS', 'RequireJS', 'Bower', 'Gulp', 'Webpack'],
                    plotOptions: {
                        bar: {
                            columnWidth: '45%',
                            distributed: true,
                        }
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    xaxis: {
                        categories: ['Browserify', 'Grunt', 'SystemJS', 'RequireJS', 'Bower', 'Yarn', 'Gulp', 'Webpack'],
                        labels: {
                            style: {
                                colors: '#fff',
                                fontSize: '14px'
                            }
                        }
                    },
                    yaxis: {
                        labels: {
                            style: {
                                color: '#FFF',
                            },
                        }
                    },
                    tooltip: {
                        theme: 'dark',
                        y: {
                            formatter: (value) => `${value}%`
                        },
                        marker: {
                            show: true
                        }
                    },
                },
                serveSeries: [{
                    name: 'Usage',
                    data: [0.9, 2.6, 1.7, 4.8, 13, 14.8, 26.5, 55.7]
                }],
            }
        },
        methods: {
            track () {
                this.$ga.page('/2018/technology/web') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 600px 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title   logo' 'content content content';
        color: white;
        text-align: center;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .logo {
            grid-area: logo;
            height: 160px;
            width: 160px;
            align-self: start;
            justify-self: end;
            background: $green;
            border-bottom-left-radius: 100%;
            display: grid;

            @media only screen and (max-width: $screen-xs-max) {
                display: none;
            }

            img {
                width: 50%;
                height: 50%;
                align-self: start;
                justify-self: end;
                margin: 20px;
            }
        }

        .title {
            grid-area: title;
            align-self: center;
            justify-self: center;
            align-content: center;
            justify-content: center;
            margin: 24px;
            display: grid;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. version module .' '. serve build .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-template-rows: auto auto;

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-areas: '. version .' '. module .' '. serve .' '. build .';
                grid-template-columns: 1fr 2fr 1fr;
            }

            .fun-fact {
                align-self: center;
                justify-self: center;
                margin: 24px;
            }

            .chart {
                width: 360px;
                align-self: center;
                justify-self: center;

                @media only screen and (max-width: $screen-xs-max) {
                    width: 250px;
                }
            }

            .chart-group {
                border-left: 2px solid $entelect-orange;
                padding-left: 24px;
                display: grid;
            }

            .chart-title {
                align-self: start;
                justify-self: start;
            }

            .chart-sub-title {
                align-self: start;
                justify-self: start;
                text-align: left;
                margin-bottom: 24px;
            }

            .java-version-chart {
                grid-area: version;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .java-serve-chart {
                grid-area: serve;
                display: grid;
                padding-top: 24px;

                .chart-sub-title {
                    width: 250px;
                }

                .fun-fact {
                    margin-top: 48px;
                }
            }

            .java-module-chart {
                grid-area: module;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                }
            }

            .java-build-chart {
                grid-area: build;
                display: grid;

                .chart-sub-title {
                    width: 250px;
                    margin: 0;
                }
            }
        }
    }
</style>
